module.exports = __webpack_public_path__ + "static/media/information.91962ea0.svg";